const __WEBPACK_NAMESPACE_OBJECT__ = require("ua-parser-js");